import { Command } from 'ckeditor5';
import { PlaceholderStore } from './store';
import { findByInstanceId } from './utils';
/** Repoints one occurrence at a different question. */
export class SetPlaceholderRefCommand extends Command {
    execute(options) {
        const { instanceId, ref } = options;
        const { editor } = this;
        const element = findByInstanceId(editor.model, instanceId);
        if (!element || element.getAttribute('id') === ref) {
            return;
        }
        // Keep the store in step before the view is rebuilt, so anything reading it during
        // reconversion sees the new ref.
        editor.plugins.get(PlaceholderStore).updatePlaceholderId(instanceId, ref);
        editor.model.change((writer) => {
            writer.setAttribute('id', ref, element);
            editor.editing.reconvertItem(element);
        });
    }
}
